// Preserve mobile clearance and cover visible Board/Utensils desktop purchase bars.
const mobile = window.matchMedia('(max-width: 749px)');
let footer;
let bars = [];
let desktopEnabled = false;
let frame = 0;
let resizeObserver;
let stateObserver;
let overlayObserver;

function update() {
  frame = 0;
  if (!footer?.isConnected) return;

  const footprint = mobile.matches || desktopEnabled ? Math.max(0, ...bars.map((bar) => {
    const active = bar.dataset.stuck === 'true' || bar.classList.contains('is-visible');
    const style = getComputedStyle(bar);
    if (!active || style.display === 'none' || style.visibility === 'hidden' || style.position !== 'fixed') return 0;

    const rect = bar.getBoundingClientRect();
    // A display:none ancestor can hide a bar even when its own computed display is flex.
    if (!rect.width || !rect.height) return 0;
    // The border box already includes env(safe-area-inset-bottom); never add it twice.
    return Math.ceil(rect.height + Math.max(0, parseFloat(style.bottom) || 0));
  })) : 0;

  let clearance = footprint;
  if (!mobile.matches && footprint) {
    const content = [...footer.querySelectorAll('a, .pf-footer__bottom p')]
      .filter((element) => element.getClientRects().length);
    const contentBottom = Math.max(...content.map((element) => element.getBoundingClientRect().bottom));
    const currentClearance = parseFloat(footer.style.getPropertyValue('--pf-pdp-sticky-clearance')) || 0;
    // Reuse existing footer end spacing; add only what is missing for a 16px gap.
    const existingGap = footer.getBoundingClientRect().bottom - contentBottom - currentClearance;
    clearance = Math.max(0, Math.ceil(footprint + 16 - existingGap));
  }

  const value = `${clearance}px`;
  if (footer.style.getPropertyValue('--pf-pdp-sticky-clearance') !== value) {
    footer.style.setProperty('--pf-pdp-sticky-clearance', value);
  }
}

function schedule() {
  if (!frame) frame = requestAnimationFrame(update);
}

function connect() {
  resizeObserver?.disconnect();
  stateObserver?.disconnect();
  overlayObserver?.disconnect();
  footer?.style.removeProperty('--pf-pdp-sticky-clearance');
  footer?.removeAttribute('data-pdp-sticky-clearance');
  footer?.removeAttribute('data-pdp-desktop-sticky-clearance');

  footer = document.querySelector('.pf-footer');
  bars = [...document.querySelectorAll(
    'sticky-add-to-cart[data-flateria-sticky-purchase] [ref="stickyBar"], [data-fti-sticky]'
  )];
  if (!footer || !bars.length) return;

  desktopEnabled = !!document.querySelector('.pf-pdp--titanium-board, .fti-hero');
  footer.setAttribute('data-pdp-sticky-clearance', '');
  footer.toggleAttribute('data-pdp-desktop-sticky-clearance', desktopEnabled);
  resizeObserver = new ResizeObserver(schedule);
  stateObserver = new MutationObserver(schedule);
  bars.forEach((bar) => {
    resizeObserver.observe(bar);
    stateObserver.observe(bar, {
      attributes: true,
      attributeFilter: ['data-stuck', 'data-overlay-hidden', 'class', 'style', 'aria-hidden', 'hidden'],
    });
  });
  overlayObserver = new MutationObserver(schedule);
  overlayObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  schedule();
}

// Recheck after CSS visibility transitions, viewport changes, and editor re-renders.
document.addEventListener('transitionend', (event) => {
  if (bars.includes(event.target)) schedule();
});
window.addEventListener('resize', schedule, { passive: true });
window.visualViewport?.addEventListener('resize', schedule, { passive: true });
window.addEventListener('pageshow', connect);
mobile.addEventListener('change', schedule);
document.addEventListener('shopify:section:load', connect);
document.addEventListener('shopify:section:unload', () => requestAnimationFrame(connect));
connect();
